export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50 relative overflow-hidden">
      <div className="max-w-[1000px] mx-auto relative z-10">
        <div className="bg-foreground-950 rounded-3xl overflow-hidden">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-[35%] relative">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20businesswoman%20in%20modern%20office%20holding%20a%20shipping%20box%20and%20smiling%20warm%20natural%20light%20from%20large%20window%20clean%20professional%20aesthetic%20editorial%20photography%20neutral%20grey%20tones&width=700&height=900&seq=testimonial-v2-p01&orientation=portrait"
                alt="Satisfied itaobuy spreadsheet user"
                className="w-full h-full object-cover object-top min-h-[300px] md:min-h-[500px]"
                loading="lazy"
              />
            </div>

            <div className="md:w-[65%] flex flex-col justify-center p-8 md:p-12 lg:p-16">
              <span className="text-background-50/15 text-7xl md:text-8xl font-heading leading-none mb-4">&ldquo;</span>
              <blockquote className="text-background-100 text-lg md:text-xl leading-relaxed mb-6">
                The itaobuy spreadsheet completely transformed how I source products. What used to take weeks of back-and-forth with agents now happens in a clean, organized system. I can track everything, compare prices, and manage bulk orders without the usual headaches.
              </blockquote>
              <div className="mb-6">
                <p className="text-background-50 font-semibold text-sm">Sarah Mitchell</p>
                <p className="text-foreground-400 text-xs">E-commerce Reseller, United States</p>
              </div>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 self-start px-5 py-2.5 rounded-full bg-primary-500/20 text-primary-300 text-sm font-medium cursor-pointer hover:bg-primary-500/30 transition-colors duration-200 whitespace-nowrap"
              >
                Read Full Review
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}